/**
 * @module components/MediaCard/VideoNexusIcon
 */
import React from 'react';
import {oneOf, string} from 'prop-types';
import style from './mediaCard.scss';

const VideoNexusIcon = ({
  type = 'default',
  assetType = '',
  mediaType = '',
}) => {
  let className = style.vnMediaCardIcon;
  if (type === 'list') className = style.vnMediaCardIconListView;

  return (
    (window.__sbgModules?._appContext?.userModel?.debugModel.getFeatureFlag(
      'videoNexus_cardIcons:enabled'
    ) &&
      mediaType === 'video' &&
      assetType === 'HMS_AWS' && (
    /* [VSE-4508] src image is uploaded by the 'frontend' repo */
        <img className={className} src="/img/video-nexus/vn-icon-only.svg" />
      )) ||
    null
  );
};

VideoNexusIcon.propTypes = {
  type: oneOf(['default', 'list']),
  assetType: string,
  mediaType: string,
};
VideoNexusIcon.defaultProps = {
  type: 'default',
  assetType: '',
  mediaType: '',
};

export {VideoNexusIcon as default};
